import React from "react";
import Navbar from "../components/shared/navbar";
import Banner from "../components/home/banner";
import Feature from "../components/home/feature";
import Benefits from "../components/home/benefits";
import Testimonials from "../components/home/testimonials";
import Team from "../components/home/team";
import Blogs from "../components/home/blogs";
import Achievements from "../components/home/achievements";
import Contact from "../components/home/contact";
import Footer from "../components/shared/footer"
import "../style/_home.scss";

const Home = () => {

  return (
    <>
      <Navbar />
      <Banner />
      <Feature />
      <Benefits />
      <Testimonials />
      <Team />
      <Blogs />
      <Achievements />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
